// extracted by mini-css-extract-plugin
export var hidden = "_p9-1";
export var visible = "_p9-0";